import { Session } from "@supabase/auth-js";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeMinimal, ThemeSupa } from "@supabase/auth-ui-shared";
import { useEffect, useState } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { Navbar } from "./components/navigation/Navbar";
import ConsentContextBanner from "./context/ConsentContextBanner";
import { CustomCategoryProvider } from "./context/CustomCatgoriesContext";
import { ExpenseLimitsProvider } from "./context/ExpenseLimitContext";
import { FixedCostsProvider } from "./context/FixedCostsContext";
import { SavingGoalsProvider } from "./context/SavingGoalsContext";
import { TransactionsProvider } from "./context/TransactionsContext";
import AddAmountMask from "./pages/AddAmountMask";
import AddCustomCategoryPage from "./pages/AddCustomCategoryPage";
import ExpenseSavingGoalsWrapper from "./pages/ExpenseSavingGoalsWrapper";
import FixedCostsPage from "./pages/FixedCostsPage";
import GeneralStatistics from "./pages/GeneralStatistics";
import Overview from "./pages/Overview";
import { supabase } from "./supabaseClient";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { Box, Container } from "@chakra-ui/react";
import { translation } from "./utils/translationLogin";

/*   const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
    });

    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => {
      data.subscription.unsubscribe();
    };
  }, []); */

/*  if (!session) {
   return (
    <Container
      maxWidth={"lg"}
      justifyContent={"center"}
      height={"100vh"}
      alignContent={"center"}
    >
      <Box flex="1" justifyItems={"center"} pb={"8"} pr={"4"}>
        <img
          src={require("./assets/finecheck-dark-font.png")}
          alt="logo von FineCheck schwarzer schriftzug mit geldscheinen"
          width={"auto"}
          style={{ maxHeight: "40px", minHeight: "20", objectFit: "contain" }}
        />
      </Box>
      <Auth
        supabaseClient={supabase}
        providers={["google"]}
        appearance={{ theme: ThemeSupa }}
        localization={translation}
      />
    </Container>
  );
 };  */

const App = () => {
  return (
    <TransactionsProvider>
      <ExpenseLimitsProvider>
        <SavingGoalsProvider>
          <FixedCostsProvider>
            <CustomCategoryProvider>
              <HashRouter>
                <ConsentContextBanner>
                  <AnalyticsTracker />
                  <Navbar supabaseClient={supabase} />
                  <Routes>
                    <Route path="/" element={<Overview />} />
                    <Route path="/add-amount" element={<AddAmountMask />} />
                    <Route path="/statistics" element={<GeneralStatistics />} />
                    <Route
                      path="/budgets-and-goals"
                      element={<ExpenseSavingGoalsWrapper />}
                    />
                    <Route path="/fixed-costs" element={<FixedCostsPage />} />
                    <Route
                      path="/add-custom-categories"
                      element={<AddCustomCategoryPage />}
                    />
                  </Routes>
                </ConsentContextBanner>
              </HashRouter>
            </CustomCategoryProvider>
          </FixedCostsProvider>
        </SavingGoalsProvider>
      </ExpenseLimitsProvider>
    </TransactionsProvider>
  );
};
export default App;
